import React from "react";
import styled from "styled-components";

const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #1570ef;
    path {
      fill: #fff;
    }
  }
`;

function Patient_AmbulanceDeparture_XmarkRegular() {
  return (
    <span style={{padding:'5px'}}>
    <Container
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" stroke="#057AFF" />
      <path
        d="M15.7632 9.36623C16.0756 9.05388 16.0756 8.54662 15.7632 8.23427C15.4509 7.92191 14.9436 7.92191 14.6313 8.23427L12 10.868L9.36623 8.23676C9.05388 7.92441 8.54662 7.92441 8.23427 8.23676C7.92191 8.54912 7.92191 9.05638 8.23427 9.36873L10.868 12L8.23676 14.6338C7.92441 14.9461 7.92441 15.4534 8.23676 15.7657C8.54912 16.0781 9.05638 16.0781 9.36873 15.7657L12 13.132L14.6338 15.7632C14.9461 16.0756 15.4534 16.0756 15.7657 15.7632C16.0781 15.4509 16.0781 14.9436 15.7657 14.6313L13.132 12L15.7632 9.36623Z"
        fill="#057AFF"
      />
    </Container>
    </span>
  );
}

export default Patient_AmbulanceDeparture_XmarkRegular;
